module.exports = __webpack_public_path__ + "static/media/slankamen1.c9db29e7.jpg";